// removed by extract-text-webpack-plugin
module.exports = {"breadcrumb":"Breadcrumb__breadcrumb___PQxo-","underline":"Breadcrumb__underline___3_O4U"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Breadcrumb/Breadcrumb.scss
// module id = 1210
// module chunks = 1